import React, { useCallback, useState } from 'react';

export default function useAccount(props) {
    const { save, user, verifyAttribute } = props;
    const [updatedFields, setUpdatedFields] = useState({});
    const [showWarnUserDialog, setShowWarnUserDialog] = useState(false);
    const [showVerify, setShowVerify] = useState(false);
    const [isEmailSent, setIsEmailSent] = useState(false);

    const handleUpdateInformation = useCallback(
        (event) => {
            event.preventDefault();
            if (updatedFields?.email && !showWarnUserDialog) {
                setShowWarnUserDialog(true);
                return;
            }

            save.mutate(updatedFields, {
                onSuccess: () => setUpdatedFields({}),
                onError: () => 'AWD'
            });
        },
        [updatedFields, save, showWarnUserDialog, setShowWarnUserDialog]
    );

    const confirmWarnUserUpdateDialog = useCallback(
        (event) => {
            handleUpdateInformation(event);
            setShowWarnUserDialog(false);
        },
        [handleUpdateInformation, setShowWarnUserDialog]
    );

    const hasEmailVerified = user?.attributes?.email_verified || false;

    const openVerifyEmail = () => {
        setIsEmailSent(true);
        verifyAttribute.execute('email');
        setShowVerify('email');
    };

    return {
        openVerifyEmail,
        isEmailSent,
        hasEmailVerified,
        confirmWarnUserUpdateDialog,
        updatedFields,
        showWarnUserDialog,
        setShowWarnUserDialog,
        showVerify
    };
}
